import { render, staticRenderFns } from "./TabVouchers.vue?vue&type=template&id=0fde2c12&scoped=true"
import script from "./TabVouchers.vue?vue&type=script&lang=js"
export * from "./TabVouchers.vue?vue&type=script&lang=js"
import style0 from "./TabVouchers.vue?vue&type=style&index=0&id=0fde2c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fde2c12",
  null
  
)

export default component.exports